import columns from '../../react-table/helpers/columns';

export default (data) => {
  const {
    FilteredNumberColumn,
    FilteredTextColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new FilteredTextColumn('Operator', 'operatorCode'),
        new FilteredNumberColumn(' Member pool storage Trays', 'trayStorageCount'),
        new FilteredNumberColumn(' Member pool storage Pallets', 'palletStorageCount'),
      ],
    },
  ];
};
